import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activateAgreement } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** D3 — the only mutation in this feature. No optimistic update: the server
 *  owns the state machine and can legitimately reject the transition with a
 *  422 (#96), and an optimistic `active` would put a false state on screen
 *  and then have to retract it. */
export function useActivateAgreementMutation(id: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (reason?: string) => activateAgreement(id, reason),
        onSuccess: () => {
            // BOTH keys. activate() writes an agreement_state_history row inside the
            // same transaction as the status change, so invalidating only the detail
            // would leave the timeline misreporting the lifecycle it exists to report.
            queryClient.invalidateQueries({ queryKey: agreementKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: agreementKeys.history(id) });
            queryClient.invalidateQueries({ queryKey: agreementKeys.financials(id) });
        },
    });
}
